import React from 'react';
import { Link } from 'react-router-dom';
import { FiAlertCircle, FiHome } from 'react-icons/fi';

function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <div className="mx-auto w-20 h-20 bg-red-500 rounded-full flex items-center justify-center mb-4">
            <FiAlertCircle className="w-12 h-12 text-white" />
          </div>
          <h1 className="text-6xl font-extrabold text-red-500 tracking-tight">
            404
          </h1>
          <h2 className="mt-4 text-3xl font-extrabold text-gray-900">
            Stránka nenalezena
          </h2>
          <p className="mt-2 text-lg text-gray-600">
            Omlouváme se, ale hledaná stránka neexistuje.
          </p>
        </div>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-lg shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
          >
            <FiHome className="mr-2" />
            Návrat na hlavní stránku
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NotFoundPage;
